import { Box, BoxProps, Heading } from "@chakra-ui/react";
import { YELLOW_COLOR } from "../const";
import { useGetCheapestCaravanPrice } from "../hooks/useGetCheapestCaravanPrice";

export const MinCaravanPrice: React.FC<BoxProps> = (props) => {
  const { cheapestCaravanPrice } = useGetCheapestCaravanPrice();

  return (
    <Box w="100%" bg={YELLOW_COLOR} p={4} {...props}>
      <Heading textAlign="center">
        Caravan Holiday Homes From Just £{cheapestCaravanPrice.toLocaleString()}
      </Heading>
    </Box>
  );
};
